import { useTranslation } from "react-i18next";

export default function Eventos() {
  const { t } = useTranslation();
  return (
    <section id="eventos-section">
      <h1>{t("nos.eventos.titulo")}</h1>
      <ul>
        <li>{t("nos.eventos.topicos.t1")}</li>
        <li>{t("nos.eventos.topicos.t2")}</li>
        <li>{t("nos.eventos.topicos.t3")}</li>
        <li>{t("nos.eventos.topicos.t4")}</li>
        <li>{t("nos.eventos.topicos.t5")}</li>
        <li>{t("nos.eventos.topicos.t6")}</li>
      </ul>
    </section>
  );
}
